import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=081226e7"
import script from "./Snackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports